import { CalendarOutlined, UploadOutlined } from "@ant-design/icons";
import { Dropdown, Flex, MenuProps } from "antd";
import { FC } from "react";

import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { RouteItem, StyledMoreOutlined, StyledRouteDropdown } from "./Styled";

export interface RouteCardProps {
    id: string;
    name: string;
    pointCount?: number;
    agentFullName: string;
    onClick?: () => void;
    onExportSingleRoute?: () => void;
    onViewByDaysOfMonth?: () => void;
    onDeleteRoute?: () => void;
    disableExport: boolean;
}

const RouteCard: FC<RouteCardProps> = ({
    id,
    name,
    pointCount,
    agentFullName,
    onClick,
    onExportSingleRoute,
    onViewByDaysOfMonth,
    onDeleteRoute,
    disableExport,
}) => {
    const dropdownItems: MenuProps["items"] = [
        ...(disableExport
            ? []
            : [
                  {
                      key: "export",
                      icon: <UploadOutlined style={{ fontSize: 20 }} />,
                      label: (
                          <PrimaryText fontSize={16}>
                              Експорт в Excel
                          </PrimaryText>
                      ),
                  },
              ]),
        {
            key: "viewByDaysOfMonth",
            icon: <CalendarOutlined style={{ fontSize: 20 }} />,
            label: (
                <PrimaryText fontSize={16}>
                    Переглянути за днями місяця
                </PrimaryText>
            ),
        },
        // {
        //     key: "delete",
        //     icon: <DeleteOutlined style={{ fontSize: 20, color: "#BF2E2D" }} />,
        //     label: (
        //         <PrimaryText fontSize={16} style={{ color: "#BF2E2D" }}>
        //             Видалити
        //         </PrimaryText>
        //     ),
        // },
    ];

    const handleMenuClick: MenuProps["onClick"] = ({ key, domEvent }) => {
        domEvent.stopPropagation();
        if (key === "export") onExportSingleRoute?.();
        if (key === "viewByDaysOfMonth") onViewByDaysOfMonth?.();
        if (key === "delete") onDeleteRoute?.();
    };

    return (
        <RouteItem key={id} onClick={onClick}>
            <Flex
                justify="space-between"
                align="center"
                style={{ width: "100%" }}
            >
                <PrimaryText fontSize={16}>{name}</PrimaryText>
                <Dropdown
                    trigger={["click"]}
                    menu={{
                        items: dropdownItems,
                        onClick: handleMenuClick,
                    }}
                    popupRender={(menu) => (
                        <StyledRouteDropdown>{menu}</StyledRouteDropdown>
                    )}
                >
                    <span onClick={(e) => e.stopPropagation()}>
                        <StyledMoreOutlined />
                    </span>
                </Dropdown>
            </Flex>

            <Flex gap="8px" justify="center" align="center">
                <SecondaryText>Кількість ТТ:</SecondaryText>
                <SecondaryText>{pointCount ?? "-"}</SecondaryText>
            </Flex>

            <Flex gap="8px" justify="center" align="center">
                <SecondaryText>ТА:</SecondaryText>
                <SecondaryText>{agentFullName}</SecondaryText>
            </Flex>
        </RouteItem>
    );
};

export default RouteCard;
